import { Button } from '@/components/ui';
import useSessionTrackingStore from '@/stores/sessionTrackingStore';

/**
 * Small fixed-position badge shown when a session is active but the
 * ConcludeSessionBar has been dismissed by the teacher.
 *
 * Clicking it un-dismisses the bar.
 */
export default function SessionActiveIndicator({ onClick }) {
  const sessionActions = useSessionTrackingStore((state) => state.sessionActions);
  const serverSessionId = useSessionTrackingStore((state) => state.serverSessionId);
  const sessionBarDismissed = useSessionTrackingStore((state) => state.sessionBarDismissed);
  const consequenceTypeLabel = useSessionTrackingStore(
    (state) => state.primaryConsequenceTypeLabel
  );
  const rosterRecordIds = useSessionTrackingStore(
    (state) => state.sessionRosterRecordIds
  );

  const isActive = Boolean(serverSessionId) || sessionActions.length > 0;

  if (!isActive || !sessionBarDismissed) return null;

  const total = sessionActions.length;
  const progress = serverSessionId && rosterRecordIds.length > 0 ?
    `${total}/${rosterRecordIds.length}` : `${total}`;

  const handleClick = () => {
    useSessionTrackingStore.getState().setSessionBarDismissed(false);
    onClick?.();
  };

  return (
    <Button
      onClick={handleClick}
      className="fixed bottom-20 right-4 z-50 flex items-center gap-6 badge badge-primary badge-lg shadow-lg cursor-pointer hover:brightness-110 transition-all"
      title="Action session remains open — click to show its register"
    >
      {/* Pulse ring */}
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-content opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-content" />
      </span>
      <span className="text-xs font-medium">
        {consequenceTypeLabel || 'Action'} session • {progress}
      </span>
    </Button>
  );
}
